import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromApp from '../../../../shared/store/app.reducer';

@Component({
    selector: 'app-claim-cme-ce-confirmation',
    templateUrl: './claim-cme-ce-confirmation.component.html',
    styleUrls: ['./claim-cme-ce-confirmation.component.css'],
})
export class ClaimCmeCeConfirmationComponent implements OnInit {
    @Input()
    name: string;

    @Input()
    capNumber: string;

    @Input()
    lab: any;

    @Input()
    kitNumber: string;

    @Output()
    closeConfirm = new EventEmitter<any>();

    @Output()
    confirm = new EventEmitter<any>();

    // staffView: boolean;
    // staffViewMemberId: string;
    // staffViewUserName: string;

    constructor(private store: Store<fromApp.AppState>) {}

    ngOnInit() {
        // this.store.select('auth').subscribe((state) => {
        //     if (state.staffViewMemberId) {
        //         this.staffViewUserName = state.staffViewUserName;
        //         this.staffViewMemberId = state.staffViewMemberId;
        //         this.staffView = true;
        //     }
        // });
    }

    onClose() {
        this.closeConfirm.emit();
    }

    onConfirm() {
        this.confirm.emit();
    }
}
